export default "__VITE_ASSET__DOT98ZKo__"